import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../core.css';
import LoadingSpinner from './LoadingSpinner';

const Login: React.FC = () => {
  const { login, user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('Login page: Checking user', { user, isLoading });
    if (!isLoading && user) {
      console.log('User authenticated, redirecting to /');
      navigate('/');
    }
  }, [user, isLoading, navigate]);

  const handleCredentialResponse = (response: { credential: string }) => {
    console.log('Received Google credential:', response.credential ? 'present' : 'missing');
    if (response.credential) {
      login(response.credential);
    } else {
      console.error('No credential received from Google');
      alert('Login failed: No credential received. Please try again.');
    }
  };

  useEffect(() => {
    // While isLoading the component renders only the spinner, so the button
    // div doesn't exist yet — wait until the real markup is on screen.
    if (isLoading) return;

    let cancelled = false;
    const initializeGoogleSignIn = () => {
      if (cancelled) return;

      // Retry until the GSI script has loaded
      if (!(window.google && window.google.accounts)) {
        console.log('Google Sign-In library not loaded, retrying...');
        setTimeout(initializeGoogleSignIn, 100);
        return;
      }

      // Retry until the button container has rendered (the old code gave up
      // here permanently, which left the button missing after auth kicks)
      const buttonDiv = document.getElementById('googleSignInButton');
      if (!buttonDiv) {
        console.log('Google Sign-In button div not rendered yet, retrying...');
        setTimeout(initializeGoogleSignIn, 100);
        return;
      }

      const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID || '102375634089-igksomsg7da11i9j1fs7psc2n16p8khn.apps.googleusercontent.com';
      if (!clientId) {
        console.error('Google Client ID is missing');
        alert('Configuration error: Google Client ID is missing.');
        return;
      }

      window.google.accounts.id.initialize({
        client_id: clientId,
        callback: handleCredentialResponse,
      });

      window.google.accounts.id.renderButton(buttonDiv, {
        theme: 'outline',
        size: 'large',
      });
    };

    initializeGoogleSignIn();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="login-container">
      <h1>Login</h1>
      <p>Please sign in with your Google account to access the app.</p>
      <div id="googleSignInButton"></div>
    </div>
  );
};

export default Login;